import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fa fa-user-circle display-1 text-muted"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "profile-avatar btn btn-icon btn-circle btn-active-color-primary bg-white shadow",
  "data-kt-image-input-action": "edit",
  title: "Edit Profile",
  "data-bs-toggle": "modal",
  "data-bs-target": "#t2o_profile_form_modal"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-camera" })
], -1)
const _hoisted_3 = {
  key: 1,
  class: "fa fa-user-circle display-1 text-muted fs-2tx"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadProfile = _resolveComponent("UploadProfile")!
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_ctx.useIcons)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_ctx.image)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "avatar-span bg-secondary",
              style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
            }, null, 4)),
        _hoisted_2,
        _createVNode(_component_UploadProfile, {
          image: _ctx.displayImage,
          onRemoveProfileAvatar: _ctx.handleRemove,
          onChangeProfileForm: _ctx.handleSave
        }, null, 8, ["image", "onRemoveProfileAvatar", "onChangeProfileForm"])
      ], 64))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.image)
          ? (_openBlock(), _createBlock(_component_el_avatar, {
              key: 0,
              class: "avatar-small bg-secondary",
              size: _ctx.size ? _ctx.size : 'medium',
              style: _normalizeStyle({ 'background-image': `url(${_ctx.image})` })
            }, null, 8, ["size", "style"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_3))
      ], 64))
}